import ComicCard from "@/components/base/ComicCard";
import { newComics } from "@/mocks/comicData";

export default function NewSection() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
              最新上架
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最新收录的韩漫作品</p>
          </div>
          <a
            href="/category/all"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看更多
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {newComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}